import { shouldForceOAuthBinding } from '@/utils/oauthBinding.js'

export default async function ({ route, redirect, $auth, $axios }) {
  if (!$auth.loggedIn || !$auth.user?.force_oauth_login) return

  if (route.name === 'auth-force-oauth' || route.name.startsWith('admin')) return

  if (route.query.state && route.query.id && route.query.provider) return

  let user = $auth.user

  if (user?.id) {
    try {
      user = await $axios.$get(`/users/${user.id}/`)
    } catch (e) {}
  }

  if (!shouldForceOAuthBinding(user)) return

  redirect({
    name: 'auth-force-oauth',
    query: { remember_url: route.fullPath }
  })
}
